var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AsiToolbar',{attrs:{"icon":_vm.icons.reports,"title":_vm.$t('uiTerms.reportsToCheck')}}),_c('ReportList',{attrs:{"report-filter-model":_vm.reportFilterModel,"hide-toolbar":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }